import React from 'react'
import { useEffect, useState, useRef } from 'react';
import { Drawer } from '@material-ui/core';
import { useDispatch, useSelector  } from "react-redux";
import TextField from '@material-ui/core/TextField';
import { makeStyles } from "@material-ui/core/styles";

import { isEmpty, DicVal} from '../modules/appLibrary';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';

/*----------------------------------------------------------------------
 * メインメニュ
 * show: true:open 
 * doClose : close call back
 -----------------------------------------------------------------------*/
export default function AccountInfo(props) {

    const [open, setOpen] = useState(false);
    const [usernm, setusernm] = useState('');
    const [passlimit, setpasslimit] = useState('');
    const [passupdate, setpassupdate] = useState('');
    const [windowheight, setwindowheight] = useState(300);
    const findwordRef1 = useRef();       //現パスワード
    const findwordRef2 = useRef();       //新しいパスワード
    const findwordRef3 = useRef();       //新しいパスワード（確認用）

    const useStyles = makeStyles((theme) => ({
        root: {
            "& .MuiFilledInput-root": {
                background: "rgb(256, 256, 256)"
            }
        }
    }));
    const classes = useStyles();


    useEffect(() => {
        setOpen(props.show)
        handleResize();
        if (props.show) {
            getData();
        }
    }, [props.show])

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    function handleResize() {
        setwindowheight(window.innerHeight);
        let h = window.innerHeight - 100;
    }

    function doClose() {
        props.doClose();
    }

    function getData() {
        props.fnc.current.postaxios('common/GetUserInfo', null,
            {
                onSuccess: function (data) {
                    setusernm(data.returnData["name"]);
                    setpasslimit(DicVal(data.returnData, "limit", "") + " " + DicVal(data.returnData, "msg", ""));
                    setpassupdate(data.returnData["passupdate"]);
                },
                errmsg: "データ取得に失敗しました"
            }
        )
    }
    function PWChange() {
        if (isEmpty(findwordRef1.current.value)) {
            props.fnc.current.warnmsg("現在のパスワードを入力してください");
            return;
        }
        if (isEmpty(findwordRef2.current.value)) {
            props.fnc.current.warnmsg("新しいパスワードを入力してください");
            return;
        }
        if (findwordRef1.current.value === findwordRef2.current.value) {
            props.fnc.current.warnmsg("現在のパスワードと新しいパスワードが同じです");
            return;
        }
        if (isEmpty(findwordRef3.current.value)) {
            props.fnc.current.warnmsg("新しいパスワード（確認用）を入力してください");
            return;
        }
        if (findwordRef2.current.value !== findwordRef3.current.value) {
            props.fnc.current.warnmsg("新しいパスワード（確認用）のパスワードが異なります");
            return;
        }
        if (!isValidPassword(findwordRef2.current.value)) {
            props.fnc.current.warnmsg("Password設定要件を満たしていません。再度Passwordを入力してください。");
            return;
        }

        let msg = "パスワードを変更します。よろしいですか？";
        props.fnc.current.confmsg(msg, () => execute());
        function execute() {
            const param = {
                "password": findwordRef1.current.value,
                "newpassword": findwordRef2.current.value,
                "newpassword_confirm": findwordRef3.current.value
            }
            props.fnc.current.postaxios('common/ChangePassword',
                {
                    "others": param
                },
                {
                    onSuccess: function (data) {
                        props.fnc.current.wait(false);
                        props.fnc.current.infomsg("パスワードを変更しました",()=>doCmd() );
                    }
                })
            function doCmd() {
                if (props.passwordChanged) {
                    props.passwordChanged();
                } else {
                    props.doClose();
                }
            }
        }
    }
    function isValidPassword(password) {
        return password.length >= 8
            && /[A-Z]/.test(password)
            && /[a-z]/.test(password)
            && /[0-9]/.test(password);
    }

    return (
         <Drawer anchor={"top"} open={open} id="accinfopanel">
             <div style={{ display: 'flex', backgroundColor: '#E7EBF0', height:windowheight}}>
                <div style={{ position: 'absolute', top: 0, left: 0 }}>
                <IconButton onClick={doClose} title="閉じる">
                    <Icon style={{ fontSize: 30 }}>close</Icon>
                </IconButton>
                </div> 
                <div style={{ position: 'absolute', top: 20, left: 100, color: '#999999', fontSize: 20 }}>アカウント情報</div>

                <div style={{ position: 'absolute', top: 100, left: 200, color: '#999999', fontSize: 15 }}>
                    <div style={{ marginBottom:20 }}>ユーザー名</div>
                    <div style={{ marginBottom: 20 }}>パスワード有効期限</div>
                    <div style={{ marginBottom: 20 }}>前回パスワード変更日</div>
                </div>
                <div style={{ position: 'absolute', top: 100, left: 400, color: '#000', fontSize: 15 }}>
                    <div style={{ marginBottom: 20 }}>{usernm}</div>
                    <div style={{ marginBottom: 20 }}>{passlimit}</div>
                    <div style={{ marginBottom: 20 }}>{passupdate}</div>
                </div>

                <div style={{ position: 'absolute', top: 250, left: 200, color: '#999999', fontSize: 15 }}>
                    <div style={{ marginBottom: 20 }}>パスワードの変更</div>
                    <div style={{ marginBottom: 5 }}>
                        <TextField
                            inputRef={findwordRef1}
                            variant="filled" size="small" placeholder=""
                            label="現在のパスワード"
                            type="password"
                            className={classes.root}
                           inputProps={{
                                style: {  fontSize: 15 , width: 300  }
                            }}
                            />
                    </div>
                    <div style={{ marginBottom: 5 }}>
                        <TextField
                            inputRef={findwordRef2}
                            variant="filled" size="small" placeholder=""
                            label="新しいパスワード"
                           type="password"
                            className={classes.root}
                            inputProps={{
                                style: { fontSize: 15, width: 300 }
                            }}
                        />
                    </div>
                    <div style={{ marginBottom: 5, color: '#666666', fontSize: 12, lineHeight: 1.6 }}>
                        8文字以上で、英大文字・英小文字・数字をそれぞれ1文字以上含めてください。
                    </div>
                    <div>
                        <TextField
                            inputRef={findwordRef3}
                            variant="filled" size="small" placeholder=""
                            label="新しいパスワード（確認用）"
                            type="password"
                            className={classes.root}
                            inputProps={{
                                style: { fontSize: 15, width: 300 }
                            }}
                        />
                    </div>
                    <span className="staplebtn" style={{ marginLeft: 220, marginTop:10 }} onClick={PWChange}>実行</span>
                </div>

             </div>
        </Drawer>
    )
}
